import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import moment from 'moment';
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { GetDataByAccountHolidayTypeIdAndYearAsync, GetDataHolidaysNextYearByAccountHolidayTypeIdAndYearAsync, resetSelectedRecordObjectInState,updatePagination, updateHolidayTypeDetailAsync, deleteAllSelectedRecordHolidayDetailAsync, getHolidaysDetailbyHolidayTypeIdAsync } from "./holidayTypeDetailSlice";
import HolidayTypeDetailItem from "./HolidayTypeDetailItem";
import HolidayTypeDetailForm from "./HolidayTypeDetailForm";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { useLocation } from 'react-router-dom';
import { ShowSwalWithConfirmationMessage } from "../../../common/SweetAlert";
import { findAllByLabelText } from "@testing-library/react";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import HolidayTypeDetailOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { DatabaseCheck } from "react-bootstrap-icons";
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/Pagination";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import PageSizeSelect from '../../../common/PageSizeSelect';
import {getFilteredList, sortData, getValueFromResource } from "../../../common/timeLiveFunction";

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const HolidayTypeDetail = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const location = useLocation();
    const { t } = useTranslation();
    const { menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const { holidayTypeDetailList, isReload, selectedRecord,MasterAccountHolidayTypeId,sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.holidayTypeDetail);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    const [holidayYearArray, SetholidayYearArray] = useState<any | ''>([]);
    const [year, setYear] = useState<string>('1900');
    const navigate = useNavigate();
    const CategorymodelRef = useRef<any>(null);
    const { obj } = location.state || {};
    const storedObjectData = localStorage.getItem('objholidaytypeId');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
   
    let AccountHolidayTypeId = '00000000-0000-0000-0000-000000000000';
     if (MasterAccountHolidayTypeId && MasterAccountHolidayTypeId !== '') {
        AccountHolidayTypeId = MasterAccountHolidayTypeId;
    } else if(objectData && objectData.AccountHolidayTypeId){
        AccountHolidayTypeId = objectData.AccountHolidayTypeId;  
     }
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const parentPageId: string = '147';
    const pageId: string = '148';

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            }
        };
        const fetchParentPagePermissions = async () => {
            if (parentPageId && parentPageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(parentPageId));
                if (!res.payload.IsList || !res.payload.IsEdit) {
                    navigate('../error/403');
                }
                else {
                    fetchPagePermissions();
                }
            }
        };
        fetchParentPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    // const getHolidaysYearAsync = async () => {
        
    //     const currentindex = holidayTypeDetailList.findIndex((item) => item.AccountHolidayTypeId == AccountHolidayTypeId);
    //     const response = await fetchAPI('api/v2/Holidays/GetDataHolidaysYear/' + AccountHolidayTypeId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
    //     const json = await response.json();
    //     console.log('GetDataHolidaysYear',json)
    //     if (Object.keys(json).length > 0) {
    //         json.map((item: any) => {
    //             item.value = item.HolidayDate;
    //             item.label = item.HolidayDate;
    //             delete item.HolidayDate;
    //         });
    //         SetholidayYearArray(json);
    //         setSelectedOptionDropDown({ value: json[0].value, label: json[0].label });
    //         dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: json[0].label }));
    //         setYear(json[0].label);

    //     } else {
    //         dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: year }));
    //     }
    // }
    const getHolidaysYearAsync = async () => {
        const currentindex = holidayTypeDetailList.findIndex((item) => item.AccountHolidayTypeId == AccountHolidayTypeId);
        const response = await fetchAPI('api/v2/Holidays/GetDataHolidaysYear/' + AccountHolidayTypeId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        if (Object.keys(json).length > 0) {
            json.map((item: any) => {
                item.value = item.HolidayDate;
                item.label = item.HolidayDate;
                delete item.HolidayDate;
            });
            SetholidayYearArray(json);
            const currentYear = new Date().getFullYear().toString();
            const selectedYear = json.find((item: any) => item.label == currentYear) || json[0];
            setSelectedOptionDropDown({ value: selectedYear.value, label: selectedYear.label });
            dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: selectedYear.label }));
            setYear(selectedYear.label);

        } else {
            dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: year }));
        }
    }

    const handleChange = (data: any) => {
        dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: data.label }));
        setSelectedOptionDropDown({ value: data.value, label: data.label });
    }

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };


    // const filteredData = holidayTypeDetailList.filter((item: any) => {
    //     const searchTermLowerCase = searchTerm.toLowerCase();

    //     return Object.values(item).some((value: any) => {
    //         if (typeof value === 'string') {
    //             return value.toLowerCase().includes(searchTermLowerCase);
    //         }
    //         return false;
    //     });
    // });


    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = holidayTypeDetailList.length;
    // const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);
    // const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    const filteredData: any = getFilteredList(holidayTypeDetailList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = holidayTypeDetailList.length;
    const recordsFiltered = filteredData.length;

    // useEffect(() => {
    //     if (isReload) {
    //         dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: year }));
    //     }

    // }, [isReload])

    useEffect(() => {
        getHolidaysYearAsync();    
        dispatch(GetDataByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: year }));
    }, [isReload,dispatch])


    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setIsModalOpen(true);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedRecordHolidayDetailAsync(holidayTypeDetailList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult[0].StatusCode === "200" ?
                                ShowToast("Holiday deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }

    const CopyNextYearClickEvent = () => {
        ShowSwalWithConfirmationMessage('Are you sure to copy specified data?', "All your existing next year data will be deleted by this action!")
            .then((result) => {

                if (result) {
                    const { value, label }: any = selectedOptionDropDown
                    dispatch(GetDataHolidaysNextYearByAccountHolidayTypeIdAndYearAsync({ AccountHolidayTypeId: AccountHolidayTypeId, HolidayYear: label }));
                    getHolidaysYearAsync();
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmationMessage:error ", error);
            });

    }

    return (
        <>
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Holiday Type Detail')} */}
                        {getValueFromResource('Holiday Type Detail',dispatch, t)}

                        </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            /> */}
                             <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}


                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div style={{ width: '150px' }}>
                            <Select
                                value={selectedOptionDropDown}
                                className='fs-7 fw-normal'
                                classNamePrefix="select"
                                isSearchable={true}
                                name="yearList"
                                onChange={handleChange}
                                options={holidayYearArray}
                            />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div style={divStyle}>
                            <button type="button" className="btn btn-sm btn-primary" onClick={CopyNextYearClickEvent}
                                style={{ marginRight: '2px', display: holidayTypeDetailList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}>
                                {/* {t('Copy Holidays to Next Year')} */}
                                {getValueFromResource('Copy Holidays to Next Year',dispatch, t)}

                            </button>
                        </div>

                        {(IsAdd || (IsDelete && holidayTypeDetailList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }
                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: holidayTypeDetailList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Holiday')} */}
                                {getValueFromResource('Add Holiday',dispatch, t)}

                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: holidayTypeDetailList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{holidayTypeDetailList.filter((item: any) => item.isSelected === 1).length}</span> 
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected',dispatch, t)}

                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: holidayTypeDetailList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <HolidayTypeDetailItem holidayTypeDetailList={currentItems} modelRef={modelRef} t={t} onopenModal={openModal} oncloseModal={closeModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }

            </div>
            {isModalOpen &&
                <HolidayTypeDetailForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
        </>
    )
};


const divStyle = {
    margin: '2px',
}
export default HolidayTypeDetail;